export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-breadcrumbs/index.ts